<template>
  <div class="vx-row mb-base justify-center">
    <!-- <vx-card title="Analytics Of Year 2024 Jul-Dec">
      <div class="vx-row flex justify-center">
        <div class="vx-col">
          <statistics-card-line
            hideChart
            class="mb-base link-gen"
            icon="LinkIcon"
            icon-right
            color="white"
            :statistic="linksCount"
            statisticTitle="Total Link Generated"
          />
        </div>
        <div class="vx-col w-1/4" style="background-color = '#2f6e92'">
          <statistics-card-line
            hideChart
            class="mb-base cust-paid"
            icon="UserCheckIcon"
            icon-right
            :statistic="paidLinksCount"
            statisticTitle="Total Customers Paid"
            color="white"
          />
        </div>
        <div class="vx-col w-1/4">
          <statistics-card-line
            hideChart
            class="mb-base rev"
            icon="CreditCardIcon"
            icon-right
            :statistic="revenue"
            statisticTitle="Total Revenue Generated"
            color="white"
          />
        </div>
      </div>
    </vx-card> -->

    <div class="vx-row justify-center">
      <div class="vx-col w-1/2">
        <vx-card class="mt-5" title="Analytics of selected date range">
          <div class="export-table mb-5">
            <div class="flex justify-center">
              <datepicker
                :disabledDates="disabledDates"
                placeholder="From Date"
                v-model="dateFrom"
              ></datepicker
              >&nbsp;&nbsp;
              <datepicker
                :disabledDates="disabledDates"
                placeholder="To Date"
                v-model="dateTo"
              ></datepicker
              >&nbsp;&nbsp;
              <vs-button
                :disabled="isFetchingAnalytics25"
                @click="fetchAnalytics25"
              >
                <span class="search-btn-content">
                  <span
                    v-if="isFetchingAnalytics25"
                    class="search-btn-spinner"
                    aria-hidden="true"
                  ></span>
                  {{ isFetchingAnalytics25 ? "Searching..." : "Search" }}
                </span>
              </vs-button
              >&nbsp;&nbsp;
              <vs-button
                type="border"
                icon-pack="feather"
                icon="icon icon-download"
                @click="downloadAnalytics()"
                >Download</vs-button
              >
            </div>
          </div>
          <div class="vx-row flex justify-center -mx-2">
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
              <statistics-card-line
                icon=""
                hideChart
                base-color="white"
                color="black"
                class="mb-base"
                :statistic="generateLinkClick25"
                statisticTitle="Links Generated"
              />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
              <statistics-card-line
                icon=""
                hideChart
                class="mb-base"
                base-color="white"
                color="black"
                :statistic="downloadClickCount25"
                statisticTitle="Download Clicks"
              />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
              <statistics-card-line
                icon=""
                hideChart
                class="mb-base"
                base-color="white"
                color="black"
                :statistic="payNowClickCount25"
                statisticTitle="PayNow Clicks"
              />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
              <statistics-card-line
                icon=""
                hideChart
                class="mb-base"
                base-color="white"
                color="black"
                :statistic="trackingClickCount25"
                statisticTitle="Tracking Clicks"
              />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
              <statistics-card-line
                icon=""
                hideChart
                base-color="white"
                color="black"
                class="mb-base"
                :statistic="editClickCount25"
                statisticTitle="Edit Clicks"
              />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
              <statistics-card-line
                icon=""
                hideChart
                class="mb-base"
                base-color="white"
                color="black"
                :statistic="customersOpenedLink25"
                statisticTitle="Customers Opened Link"
              />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
              <statistics-card-line
                icon=""
                hideChart
                class="mb-base"
                base-color="white"
                color="black"
                :statistic="paidLinksCount25"
                statisticTitle="Customers Paid via link"
              />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2" v-if="systemId === 9">
              <statistics-card-line
                icon=""
                hideChart
                class="mb-base"
                base-color="white"
                color="black"
                :statistic="bhxUpliftEligible25"
                statisticTitle="BHX uplift eligible"
              />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2" v-if="systemId === 9">
              <statistics-card-line
                icon=""
                hideChart
                class="mb-base"
                base-color="white"
                color="black"
                :statistic="bhxUpliftExecutiveChosen25"
                statisticTitle="BHX uplift executive chosen"
              />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
              <statistics-card-line
                icon=""
                hideChart
                class="mb-base"
                base-color="white"
                color="black"
                :statistic="revenue25"
                statisticTitle="Total Revenue generated"
              />
            </div>
          </div>
        </vx-card>
      </div>
      <!-- <div v-show="this.pieChart.series" class="vx-col w-1/2">
        <vx-card class="mt-5" title="Graphical Representation Of User Clicks">
          <vue-apex-charts
            :key="chartKey"
            type="pie"
            height="350"
            :options="pieChart.chartOptions"
            :series="pieChart.series"
          ></vue-apex-charts>
        </vx-card>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
import { getAnalytics, getAnalytics2024, downloadAnalytics } from "@/services/analytics.js";

import Datepicker from "vuejs-datepicker";
import moment from "moment";

import FeatherIcon from "@/components/FeatherIcon.vue";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";

import VueApexCharts from "vue-apexcharts";

export default {
  data() {
    return {
      responseData: {},


      disabledDates: {
        to: new Date(new Date().getFullYear(), new Date().getMonth() - 2), // Disable all dates up to specific date
        from: new Date(), // Disable all dates after specific date
      },
      systemId: this.$store.state.AppActiveUser.systemId,
      buttonCount: 0,
      linksCount: 0,
      paidLinksCount: 0,
      revenue: 0,

      dateFrom: "",
      dateTo: "",

      downloadClickCount25: 0,
      generateLinkClick25: 0,
      payNowClickCount25: 0,
      editClickCount25: 0,
      trackingClickCount25: 0,
      customersOpenedLink25: 0,
      paidLinksCount25: 0,
      bhxUpliftEligible25: 0,
      bhxUpliftExecutiveChosen25: 0,
      revenue25: 0,
      percentages: null,
      exportData: [],


      themeColors: ["#49c5b0", "#ec6e5a", "#2f6e92","#ab208e", "#5fb0df"],
      isFetchingAnalytics25: false,
      chartKey: 0,
      pieChart: {
        series: [],
        chartOptions: {
          labels: [],
          colors: this.themeColors,
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      },
    };
  },
  components: {
    VueApexCharts,
    FeatherIcon,
    StatisticsCardLine,
    Datepicker,
  },
  mounted() {
    this.$vs.loading();
    // this.fetchAnalytics();
    this.fetchAnalytics25();
  },

  created() {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    // Format as YYYY-MM-DD
    this.dateTo = today.toISOString().split("T")[0];
    this.dateFrom = sevenDaysAgo.toISOString().split("T")[0];
  },

  methods: {
    formatDateToYMD(date) {
      return new Date(date).toISOString().split("T")[0];
    },
    fetchAnalytics() {
      getAnalytics2024().then((res) => {
        this.linksCount = res.data.total_customers;
        const formattedGBP = new Intl.NumberFormat('en-GB', {
                    style: 'currency',
                    currency: 'GBP',
                  }).format(res.data.total_revenue);

        this.revenue = formattedGBP;
        this.paidLinksCount = res.data.total_paid_customers;
      });
    },

    fetchAnalytics25() {
      if (this.isFetchingAnalytics25) return;
      this.isFetchingAnalytics25 = true;
      this.$vs.loading();

      const data = {
        startDate: this.dateFrom,
        endDate: this.dateTo,
      };

      getAnalytics(data)
      .then((res) => {
        this.responseData = res.data;

        this.downloadClickCount25 = res.data.button_counts.download || 0;
        this.editClickCount25 = res.data.button_counts.edit || 0;
        this.trackingClickCount25 = res.data.button_counts.tracking || 0;
        this.generateLinkClick25 = res.data.button_counts.generate_link || 0;
        this.payNowClickCount25 = res.data.button_counts.pay_now || 0;
        this.bhxUpliftEligible25 = res.data.button_counts.bhx_uplift_eligible || 0;
        this.bhxUpliftExecutiveChosen25 = res.data.button_counts.bhx_uplift_executive_chosen || 0;

        // Analytics data
        this.customersOpenedLink25 = res.data.button_counts.opened_link || 0;
        this.paidLinksCount25 = res.data.summary.paid_bookings|| 0;

        // const percentages  = res.data.percentage;
        const revenue = parseInt(res.data.summary.payments_total_paid_amount);
        // this.exportData = res.data.bookings;

        // Automatically generate display labels from keys (e.g., pay_now → Pay Now)
        // const formatLabel = (key) =>
        //   key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

        // Get all keys (ensures flexibility for growing datasets)
        // const keys = Object.keys(percentages);
        // const seriesData = keys.map((key) => percentages[key] || 0);
        // const displayLabels = keys.map(formatLabel);

        // Update chart data
        // this.pieChart.series = seriesData;
        // this.pieChart.chartOptions = {
        //   ...this.pieChart.chartOptions,
        //   labels: displayLabels,
        //   colors: this.themeColors,
        // };
        // this.chartKey++; // force ApexChart re-render

        // Button counts (with safe fallbacks)


        const formatGBP = new Intl.NumberFormat('en-GB', {
                    style: 'currency',
                    currency: 'GBP',
                  }).format(revenue || 0);

                  console.log(formatGBP);
                  
        this.revenue25  = formatGBP

      })
      .catch((error) => {
        const errorMessage =
          (error && error.message) ||
          (error && error.response && error.response.data && error.response.data.responseMessage) ||
          "Failed to fetch analytics";
        this.$vs.notify({
          title: "Error",
          text: errorMessage,
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      })
      .finally(() => {
        this.isFetchingAnalytics25 = false;
        this.$vs.loading.close();
      });
    },

    downloadAnalytics() {
      this.$vs.loading();
        import("@/vendor/Export2Excel").then((excel) => {
          this.$vs.loading.close();

          const bookings = this.exportData;

          // Define the button type columns
          const buttonTypes = ['generate_link', 'pay_now', 'download', 'tracking', 'edit', 'opened_link'];
          const customLabels = ['Link generated', 'Paynow Clicks','Download Clicks','Tracking Clicks','Edit Clicks','Customer opened link']
          // Define header row
          const rows = [
            ['Date and time ', 'Booking ID', ...customLabels, 'Paid via link', 'Revenue']
          ];
          const totals = {
            generate_link: 0,
            pay_now: 0,
            download: 0,
            tracking: 0,
            edit: 0,
            opened_link: 0,
            paid_via_link: 0,
            total_paid_amount: 0,
          };

          bookings.forEach(booking => {

            const row = [booking.created_at, booking.booking_id];

            // Fill 1/0 for each button type
            buttonTypes.forEach((type) => {
              let hasType = 0;
              if (type === "bhx_uplift_eligible" || type === "bhx_uplift_executive_chosen") {
                hasType = booking[type] ? 1 : 0;
              } else {
                // row.push(booking.button_type.includes(type) ? 1 : 0);
                hasType = booking.button_type.includes(type) ? 1 : 0;
              }
              row.push(hasType);
              totals[type] += hasType;
            });

            // Add amount and transaction count
            row.push(booking.paid_via_link);
            row.push(booking.total_paid_amount);
            totals.paid_via_link += booking.paid_via_link;
            totals.total_paid_amount += booking.total_paid_amount;

            rows.push(row);
          });

          rows.push([
            'Total', '', // Date and Booking ID columns
            totals.generate_link,
            totals.pay_now,
            totals.download,
            totals.tracking,
            totals.edit,
            totals.opened_link,
            totals.paid_via_link,
            totals.total_paid_amount
          ]);

          excel.export_json_to_excel({
            header: [],
            data: rows,
            filename: `Bookings-${moment().format("YYYY-MM-DD")}`,
            autoWidth: false,
            bookType: "xls"
          });
        });
    },

  },
};
</script>
<style scoped>
.link-gen {
  background-color: #ecbd5a !important;
}
.cust-paid {
  background-color: #ab208e !important;
  }
.rev {
  background-color: #2f6e92 !important;
}

.search-btn-content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.search-btn-spinner {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  border: 2px solid rgba(37, 99, 235, 0.25);
  border-top-color: rgba(37, 99, 235, 0.95);
  animation: analyticsSpin 0.8s linear infinite;
  flex: 0 0 auto;
}

@keyframes analyticsSpin {
  to {
    transform: rotate(360deg);
  }
}
</style>
